// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a2ERn","colMin":"styles_colMin__sD4Cm"};